import React from 'react';
import ReactTable from 'react-table';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchBar from 'components/common/SearchBar';
import DatatableHelper from 'utils/DatatableHelper';
import Modal from 'react-responsive-modal';
import { Colors, Sizes, ButtonGroup, Button } from 'react-foundation';
import { API } from 'api/APIClient';
import TableContainer from 'components/common/TableContainer';
import AppComponent from 'components/common/AppComponent';
import { NotificationManager } from "react-notifications";
import StandardModal from 'components/common/StandardModal';
import DateHelper from 'utils/DateHelper';
import PageContent from 'components/common/PageContent';

const pathElements = [
    { id: 0, title: "Home", url: "/" },
    { id: 1, title: "Chat Flows", url: "/chatflows" },
    { id: 2, title: "Groups" }
];

class ChatFlowGroupsTable extends AppComponent {

    constructor(props) {
        super(props);

        this.state = {
            items: [],
            item: {
                id: null,
                name: "",
                importReady: 0
            },
            searchKey: "",
            page: 0,
            pageSize: 10,
            sorted: [{ id: "name", desc: false }],
            totalPages: -1,
            isLoading: true,
            modal: {
                isOpen: false,
                mode: null,
                isUploading: false,
                error: null
            }
        };

        this.searchTimer = null;
    }

    componentDidMount() {
        this.fetchItems();
    }

    searchTextDidChange = (newValue) => {
        this.setState({
            searchKey: newValue || ""
        }, () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.fetchItems();
            }, 1000);
        });
    }

    fetchItems = () => {
        this.setState({
            isLoading: true
        });

        Axios
            .post(API.chatFlowGroup.getChatFlowGroupsDT, {
                page: this.state.page,
                pageSize: this.state.pageSize,
                sorted: this.state.sorted,
                filters: {
                    search: this.state.searchKey
                }
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        items: res.data.data.rows,
                        totalPages: DatatableHelper.getTotalPages(res.data.data),
                        isLoading: false
                    });
                }
                else {
                    this.setState({
                        isLoading: false
                    });
                }
            })
            .catch(() => {
                this.setState({
                    isLoading: false
                });
            });
    }

    openItemModal = (item) => {
        this.setState({
            item: {
                id: item.id || null,
                name: item.name || "",
                importReady: item.importReady !== undefined && item.importReady !== null ? Number(item.importReady) : 0
            },
            modal: {
                isOpen: true,
                mode: "edit",
                isUploading: false,
                error: null
            }
        });
    }

    handleAddNewItem = () => {
        this.openItemModal({});
    }

    handleEditItem = (item) => {
        this.openItemModal(item);
    }

    closeModal = (completion) => {
        if (this.state.modal.isOpen) {
            this.setState({
                item: {
                    id: null,
                    name: "",
                    importReady: 0
                },
                modal: {
                    isOpen: false,
                    mode: null,
                    isUploading: false,
                    error: null
                }
            }, () => {
                if (completion instanceof Function) {
                    completion();
                }
            });
        }
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        let item = Object.assign({}, this.state.item);
        item[name] = value;

        this.setState({
            item: item,
            modal: Object.assign({}, this.state.modal, {
                error: null
            })
        });
    }

    handleSubmit = () => {
        if (this.state.modal.isUploading) {
            return;
        }

        const isEdit = this.state.item.id !== null && this.state.item.id !== undefined;
        const name = (this.state.item.name || "").trim();
        if (name.length === 0) {
            this.setState({
                modal: Object.assign({}, this.state.modal, {
                    error: "Name is required"
                })
            });
            return;
        }

        const payload = {
            name: name,
            importReady: this.state.item.importReady ? 1 : 0
        };

        if (this.state.item.id) {
            payload.id = this.state.item.id;
        }

        const request = this.state.item.id ? API.chatFlowGroup.updateChatFlowGroup : API.chatFlowGroup.createChatFlowGroup;

        this.setState({
            modal: Object.assign({}, this.state.modal, {
                isUploading: true,
                error: null
            })
        }, () => {
            Axios.post(request, payload)
                .then((res) => {
                    if (res.data.success) {
                        this.closeModal(() => {
                            this.fetchItems();
                            NotificationManager.success(isEdit ? "Chat Flow Group updated" : "Chat Flow Group created");
                        });
                    }
                    else {
                        this.setState({
                            modal: Object.assign({}, this.state.modal, {
                                isUploading: false,
                                error: res.data.error && res.data.error.desc ? res.data.error.desc : "Unknown error"
                            })
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        modal: Object.assign({}, this.state.modal, {
                            isUploading: false,
                            error: error.response ? (error.response.data && error.response.data.error && error.response.data.error.desc ? error.response.data.error.desc : "Request failed") : "Request failed"
                        })
                    });
                });
        });
    }

    showDeleteModal = (item) => {
        if (!this.state.modal.isOpen) {
            this.setState({
                item: item,
                modal: {
                    isOpen: true,
                    mode: "delete",
                    isUploading: false,
                    error: null
                }
            });
        }
    }

    handleDeleteItem = (item) => {
        if (this.state.modal.isUploading) {
            return;
        }

        this.setState({
            modal: Object.assign({}, this.state.modal, {
                isUploading: true
            })
        }, () => {
            Axios
                .post(API.chatFlowGroup.deleteChatFlowGroup, {
                    id: item.id
                })
                .then((res) => {
                    if (res.data.success) {
                        this.closeModal(() => {
                            this.fetchItems();
                            NotificationManager.success("Chat Flow Group deleted");
                        });
                    }
                    else {
                        this.closeModal(() => {
                            NotificationManager.error(res.data.error.desc);
                        });
                    }
                })
                .catch(error => {
                    this.closeModal(() => {
                        NotificationManager.error(error.response);
                    });
                });
        });
    }

    renderModalContent = () => {
        if (this.state.modal.mode === "delete") {
            return (
                <StandardModal
                    title="Delete Chat Flow Group"
                    content={(
                        <div>Are you sure to delete <strong>{this.state.item.name}</strong> chat flow group ? This action cannot be reverted.</div>
                    )}
                    buttons={(
                        <React.Fragment>
                            <button className="button secondary" type="button" onClick={this.closeModal}>
                                Cancel
                            </button>
                            <button className="button alert" type="button" onClick={() => this.handleDeleteItem(this.state.item)}>
                                Delete
                            </button>
                        </React.Fragment>
                    )}
                    isUploading={this.state.modal.isUploading}
                />
            );
        }

        return (
            <StandardModal
                title={this.state.item.id ? "Edit Chat Flow Group" : "Add New Group"}
                content={(
                    <React.Fragment>
                        <div className="grid-x grid-padding-x">
                            <div className="small-12 cell">
                                <label htmlFor="name">Name</label>
                                <input
                                    name="name"
                                    type="text"
                                    value={this.state.item.name || ""}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                        <div className="grid-x grid-padding-x" style={{marginTop: 10}}>
                            <div className="small-12 cell">
                                <label htmlFor="importReady" style={{display: "inline-block"}}>Import Ready</label>
                                <label className="chkbx-container" style={{display: "inline-block", marginLeft: 10}}>
                                    <input
                                        className="chkbx"
                                        type="checkbox"
                                        name="importReady"
                                        onChange={this.handleChange}
                                        checked={Number(this.state.item.importReady) === 1}
                                    />
                                    <span className="chkmk"></span>
                                </label>
                            </div>
                        </div>
                    </React.Fragment>
                )}
                buttons={(
                    <React.Fragment>
                        <button className="button secondary" type="button" onClick={this.closeModal}>
                            Cancel
                        </button>
                        <button className="button" type="button" onClick={this.handleSubmit}>
                            {this.state.item.id ? "Update" : "Create"}
                        </button>
                    </React.Fragment>
                )}
                error={this.state.modal.error}
                isUploading={this.state.modal.isUploading}
            />
        );
    }

    render() {
        const columns = [
            {
                Header: 'ID',
                accessor: 'id',
                maxWidth: 60
            },
            {
                Header: 'Group Name',
                accessor: 'name'
            },
            {
                Header: 'Import Ready',
                accessor: 'importReady',
                Cell: row => {
                    return Number(row.value) === 1 ? "Yes" : "No";
                }
            },
            {
                Header: 'Created At',
                accessor: 'createdAt',
                maxWidth: 180,
                Cell: row => {
                    return DateHelper.convertToLocalDateTime(row.value);
                }
            },
            {
                Header: 'Actions',
                Cell: row => (
                    <ButtonGroup size={Sizes.TINY}>
                        <Button color={Colors.PRIMARY} onClick={() => this.handleEditItem(row.original)}>
                            <FontAwesomeIcon icon="edit" />
                        </Button>
                        <Button color={Colors.ALERT} onClick={() => this.showDeleteModal(row.original)}>
                            <FontAwesomeIcon icon="trash" />
                        </Button>
                    </ButtonGroup>
                ),
                maxWidth: 140,
                sortable: false,
                className: "center"
            }
        ];

        const table = (
            <ReactTable
                columns={columns}
                data={this.state.items}
                pages={this.state.totalPages}
                pageSize={this.state.pageSize}
                loading={this.state.isLoading}
                multisort={true}
                manual
                className='-striped'
                onFetchData={(state) => {
                    this.setState({
                        page: state.page,
                        pageSize: state.pageSize,
                        sorted: state.sorted
                    }, () => {
                        this.fetchItems();
                    });
                }}
            />
        );

        const filters = (
            <React.Fragment>
                <div className="cell small-12 medium-6 large-3">
                    <span>Search</span>
                    <SearchBar
                        onDidChange={(newValue) => this.searchTextDidChange(newValue)}
                    />
                </div>
            </React.Fragment>
        );

        const buttons = (
            <React.Fragment>
                <button type="button" className="button small" onClick={this.handleAddNewItem}>Add New Group</button>
            </React.Fragment>
        );

        return (
            <PageContent pathElements={pathElements}>
                <TableContainer
                    title="Chat Flow Groups"
                    buttons={buttons}
                    filters={filters}
                    table={table}
                />
                <Modal
                    classNames={{modal: "modal-medium"}}
                    open={this.state.modal.isOpen}
                    modalId="ChatFlowGroupsModal"
                    onClose={this.closeModal}
                    center
                >
                    {this.renderModalContent()}
                </Modal>
            </PageContent>
        );
    }
}

export default ChatFlowGroupsTable;
